<main [@fadeInOut] class="container-fluid" role="main" id="main-heading" tabindex="0">
  <div class="col-sm-11 mx-auto d-flex flex-column main-heading-div">
    <div class="mt-3">
      <h1 *ngIf="!displayEditScreen && !showEUDForm && !showSKForm">Client Admin Settings</h1>
    </div>
    <div [ngClass]="{'extra-top-space': (!displayEditScreen && languageTabEnabled) || !languageTabEnabled}">
      <nav ngbNav #tabset="ngbNav" [(activeId)]="activeTab" (navChange)="tabChanged($event)" class="nav-tabs" id="tabset" tabindex="0">
        <ng-container ngbNavItem="clientAdmin" *ngIf="clientAdminTabEnabled">
          <a ngbNavLink role="tab" tabindex="0">
            <span aria-label="API Credentials">Api Credentials</span>
          </a>
          <ng-template ngbNavContent>
            <div class="row">
              <div class="col-sm-10" *ngFor="let appVar of applicationVariants; let i = index">
                <!-- Displaying a link vs a form. If the Add icon is clicked then display a form -->
                <div *ngIf="showLink" class="col-sm-7">
                  <div *ngIf="hasApiAccess(appVar.applicationVariantName)" class="haLink">
                    <h3>{{appVar.applicationVariantName}}</h3>
                    <div class="top-space small-rule pt-3">
                      <div *ngIf="getHA(appVar) && (getHA(appVar)[0])?.credentialIds.length; else nonExistingHA">

                        <!-- If api credentials data is there and there are credentials show them, otherwise display links-->
                        <div class="title-div"
                             *ngFor="let credential of (getHA(appVar)[0])?.credentialIds; let c = index">
                          <a href="javascript:void(0);" class="fa-1-35x" role="button"
                             (click)='linkClicked(appVar.applicationVariantName, credential)'>
                            <i [ngClass]="getIconClass(appVar.applicationVariantName, credential)"
                               aria-hidden="true"></i>
                            <span class="left-padding-8">{{haDisplayedText(appVar.applicationVariantName)}}</span>
                            <span class="accent-text">{{credential}}</span>
                          </a>
                        </div>

                      </div>
                    </div>
                    <ng-template #nonExistingHA>

                      <a href="javascript:void(0);" (click)="addLinkClicked(appVar.applicationVariantName)"
                         role="button" aria-label="Displayed credential"
                         *ngIf="appVar.applicationVariantName === dataScopeEnum.SKOREA">
                        <i class="fal fa-plus-circle fa-lg"></i>
                        <span class="left-padding-8 fa-1-35x">{{haDisplayedText(appVar.applicationVariantName)}}</span>
                      </a>
                    </ng-template>

                    <!-- For Eudamed always show a link to add an additional SRN -->
                    <div class="mt-4 title-div" *ngIf="appVar.applicationVariantName === dataScopeEnum.EUDAMED">
                      <a href="javascript:void(0);" role="button" aria-label="Add SRN and Access Token"
                         (click)="addLinkClicked(appVar.applicationVariantName)">
                        <i class="fa fa-plus-circle fa-lg">
                        </i>
                        <span class="left-padding-8 fa-1-35x">Add SRN and Access Token</span>
                      </a>
                    </div>
                    <!-- For AU always show a link to add an additional TBS ID -->
                    <div class="mt-4 title-div" *ngIf="appVar.applicationVariantName === dataScopeEnum.AU">
                      <a href="javascript:void(0);" role="button" aria-label="Add TBS ID and Subscription Key"
                         (click)="addLinkClicked(appVar.applicationVariantName)">
                        <i class="fa fa-plus-circle fa-lg">
                        </i>
                        <span class="left-padding-8 fa-1-35x">Add TBS ID and Subscription Key</span>
                      </a>
                    </div>
                    <!-- For Swissdamed always show a link to add an additional CHRN -->
                    <div class="mt-4 title-div" *ngIf="appVar.applicationVariantName === dataScopeEnum.SWISSDAMED">
                      <a href="javascript:void(0);" role="button" aria-label="Add CHRN and API Credentials"
                         (click)="addLinkClicked(appVar.applicationVariantName)">
                        <i class="fa fa-plus-circle fa-lg">
                        </i>
                        <span class="left-padding-8 fa-1-35x">Add CHRN and API Credentials</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div id="comingSoon" *ngIf="!anyHAhasPermission() && !languageTabEnabled && !loading">
                <div class="top-space small-rule haLink">
                  <span class="left-padding-8">Coming soon..</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 apicredential-form">
                <div *ngIf="showSKForm">

                  <form [formGroup]="apiSKForm" name="apiSKForm" (keydown.enter)="$event.preventDefault()" novalidate
                        autocomplete="off">
                    <h3 aria-label="Add South Korea Credentials" class="mt-5">
                      Add South Korea Credentials
                    </h3>
                    <div class="d-flex flex-column">
                      <div class="row mt-3">
                        <div class="col-sm-9 form-group">
                          <label class="form-label-control" aria-label="South Korea Client ID" for="clientId">
                            South Korea Client ID
                          </label>
                          <ejs-textbox formControlName="clientId" type="text" name="clientId"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.clientId }" autocomplete="off">
                          </ejs-textbox>

                          <div *ngIf="formErrors?.clientId" class="alert-text">
                            {{formErrors?.clientId}}
                          </div>
                        </div>

                      </div>
                      <div class="row mt-2">

                        <div class="col-sm-9 form-group">
                          <label class="form-label-control" aria-label="South Korea Client Secret (Password)"
                                 for="clientPassword">
                            South
                            Korea Client Secret (Password)
                          </label>
                          <ejs-textbox formControlName="clientPassword" type="text" name="clientPassword"
                                       class="no-password-show"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.clientPassword }" autocomplete="off"
                                       (focus)="changeInputType('clientPassword')">
                          </ejs-textbox>

                          <div *ngIf="formErrors?.clientPassword" class="alert-text">
                            {{formErrors?.clientPassword}}
                          </div>
                        </div>

                      </div>
                      <div class="row mt-2">
                        <div class="col-sm-12">
                          <div class="col-sm-9 form-group">
                            <label class="form-label-control" aria-label="Confirm South Korea Client Secret(Password)"
                                   for="clientPassword">Confirm South Korea Client Secret(Password)</label>

                            <ejs-textbox formControlName="comparePassword" type="text" name="comparePassword"
                                         class="no-password-show"
                                         [ngClass]="{required:true, 'is-invalid': formErrors?.comparePassword }"
                                         (keyup)="onKeyUp($event, dataScopeEnum.SKOREA.toLowerCase())"
                                         (focus)="changeInputType('comparePassword')" autocomplete="off">
                            </ejs-textbox>

                            <div *ngIf="formErrors?.comparePassword" class="alert-text">
                              {{formErrors?.comparePassword}}
                            </div>
                            <div *ngIf="apiSKFormControls.comparePassword.touched && !isMatch" class="alert-text">
                              <span aria-label="The Client Secret and Confirm Client Secret must match.">
                                The Client
                                Secret
                                and
                                Confirm Client Secret must match.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="d-flex flex-row mt-5 form-group justify-content-center">
                          <div class="col-sm-9">
                            <button class="btn btn-default dialogButton" id="cancel" (click)="cancelForm()"
                                    aria-label="Cancel">
                              Cancel
                            </button>
                            <button class="btn btn-primary dialogButton" id="save" (click)="saveSKForm()"
                                    aria-label="Save">
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div *ngIf="showAUForm" class="col-sm-12 apicredential-form">
                <form [formGroup]="apiAUForm" name="apiAUForm" (keydown.enter)="$event.preventDefault()" novalidate
                      autocomplete="off">
                  <h3 class="mt-5" aria-label="Add TBS ID and Subscription Key">
                    Add Australia TBS ID and Subscription Key
                  </h3>
                  <div class="d-flex flex-column">
                    <div class="row mt-2">
                      <div class="col-sm-12 top-space">
                        <div class="col-sm-9 form-group pe-3">
                          <label class="form-label-control" aria-label="TBS ID "
                                 for="clientId">
                            TBS ID
                          </label>
                          <ejs-textbox formControlName="tbsid" type="text" name="tbsid"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.tbsid }" autocomplete="off"
                                       class="upper-case-input" maxlength="250" (keyup)="clearFieldErrors('tbsid')">
                          </ejs-textbox>
                          <div *ngIf="formErrors?.tbsid" class="alert-text">
                            {{formErrors?.tbsid}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-sm-12 d-flex flex-row">
                        <div class="col-sm-9 form-group pe-3">
                          <label class="form-label-control" for="clientPassword" aria-label="Subscription Key">
                            Subscription Key*
                          </label>
                          <ejs-textbox formControlName="subscriptionKey" type="text" name="subscriptionKey"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.subscriptionKey }" autocomplete="off"
                                       maxlength="250" (keyup)="onKeyUpAccessToken($event)" (focus)="changeInputType('subscriptionKey'); ">
                          </ejs-textbox>

                          <div *ngIf="formErrors?.subscriptionKey" class="alert-text">
                            {{formErrors?.subscriptionKey}}
                          </div>
                        </div>
                        <div class="col-sm-3 text-left">
                          <i *ngIf="showEyeIcon" id="pass-status" class="fal fa-eye" aria-hidden="true"
                             (click)="viewPassword('subscriptionKey')"></i>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-sm-12 d-flex flex-row">
                        <div class="col-sm-9 form-group pe-3">
                          <label class="form-label-control" aria-label="Confirm Subscription Key*"
                                 for="compareSubscriptionKey">
                            Confirm
                            Subscription Key*
                          </label>
                          <ejs-textbox formControlName="compareSubscriptionKey" type="text" name="compareSubscriptionKey"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.compareSubscriptionKey }"
                                       autocomplete="off"
                                       (keyup)="onKeyUp($event, dataScopeEnum.AU.toLowerCase());onKeyUpAccessTokenCompare($event)"
                                       (focus)="changeInputType('compareSubscriptionKey'); ">
                          </ejs-textbox>

                          <div *ngIf="formErrors?.compareSubscriptionKey" class="alert-text">
                            {{formErrors?.compareSubscriptionKey}}
                          </div>
                          <div *ngIf="apiAUFormControls.compareSubscriptionKey.touched && !isMatch" class="alert-text">
                            <span aria-label="The Subscription Key and Confirm Subscription Key must match">
                              The Subscription Key and
                              Confirm Subscription Key must match
                            </span>
                          </div>
                        </div>
                        <div class="col-sm-1 text-left no-left-padding">
                          <i *ngIf="showEyeIconCompare" id="pass-status-compare" class="fal fa-eye" aria-hidden="true"
                             (click)="viewPasswordCompare('compareSubscriptionKey')"></i>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <div class="col-sm-9 form-group">
                          <span aria-label="*Required fields" class="small-print">*Required fields</span>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="d-flex flex-row mt-5 form-group justify-content-center">
                        <div class="col-sm-9">
                          <button class="btn btn-default dialogButton" id="cancel" (click)="cancelForm()"
                                  aria-label="Cancel">
                            Cancel
                          </button>
                          <button class="btn btn-primary dialogButton" id="save" (click)="saveAUForm()"
                                  aria-label="Save">
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="showEUDForm" class="col-sm-12 apicredential-form">
                <form [formGroup]="apiEUDForm" name="apiEUDForm" (keydown.enter)="$event.preventDefault()" novalidate
                      autocomplete="off">
                  <h3 class="mt-5" aria-label="Add EUDAMED SRN and Access Token">
                    Add EUDAMED SRN and Access
                    Token
                  </h3>
                  <div class="d-flex flex-column">
                    <div class="row mt-2">
                      <div class="col-sm-12 top-space">
                        <div class="col-sm-9 form-group pe-3">
                          <label class="form-label-control" aria-label="SRN (Example: BE-MF-123456789)*"
                                 for="clientId">
                            SRN
                            (Example: BE-MF-123456789)*
                          </label>
                          <ejs-textbox formControlName="srn" type="text" name="srn"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.srn }" autocomplete="off"
                                       class="upper-case-input" (keyup)="clearFieldErrors('srn')">
                          </ejs-textbox>
                          <div *ngIf="formErrors?.srn" class="alert-text">
                            {{formErrors?.srn}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-sm-12 d-flex flex-row">
                        <div class="col-sm-9 form-group pe-3">
                          <label class="form-label-control" for="clientPassword" aria-label="Access Token">
                            Access
                            Token*
                          </label>
                          <ejs-textbox formControlName="accessToken" type="text" name="accessToken"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.accessToken }" autocomplete="off"
                                       (keyup)="onKeyUpAccessToken($event)" (focus)="changeInputType('accessToken'); ">
                          </ejs-textbox>

                          <div *ngIf="formErrors?.accessToken" class="alert-text">
                            {{formErrors?.accessToken}}
                          </div>
                        </div>
                        <div class="col-sm-3 text-left">
                          <i *ngIf="showEyeIcon" id="pass-status" class="fal fa-eye" aria-hidden="true"
                             (click)="viewPassword('accessToken')"></i>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-sm-12 d-flex flex-row">
                        <div class="col-sm-9 form-group pe-3">
                          <label class="form-label-control" aria-label="Confirm Access Token*"
                                 for="compareAccessToken">
                            Confirm
                            Access Token*
                          </label>
                          <ejs-textbox formControlName="compareAccessToken" type="text" name="compareAccessToken"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.compareAccessToken }"
                                       autocomplete="off"
                                       (keyup)="onKeyUp($event, dataScopeEnum.EUDAMED.toLowerCase());onKeyUpAccessTokenCompare($event)"
                                       (focus)="changeInputType('compareAccessToken'); ">
                          </ejs-textbox>

                          <div *ngIf="formErrors?.compareAccessToken" class="alert-text">
                            {{formErrors?.compareAccessToken}}
                          </div>
                          <div *ngIf="apiEUDFormControls.compareAccessToken.touched && !isMatch" class="alert-text">
                            <span aria-label="The Access Token and Confirm Access Token must match">
                              The Access Token and
                              Confirm Access Token must match
                            </span>
                          </div>
                        </div>
                        <div class="col-sm-1 text-left no-left-padding">
                          <i *ngIf="showEyeIconCompare" id="pass-status-compare" class="fal fa-eye" aria-hidden="true"
                             (click)="viewPasswordCompare('compareAccessToken')"></i>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <div class="col-sm-9 form-group">
                          <span aria-label="*Required fields" class="small-print">*Required fields</span>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="d-flex flex-row mt-5 form-group justify-content-center">
                        <div class="col-sm-9">
                          <button class="btn btn-default dialogButton" id="cancel" (click)="cancelForm()"
                                  aria-label="Cancel">
                            Cancel
                          </button>
                          <button class="btn btn-primary dialogButton" id="save" (click)="saveEUDForm()"
                                  aria-label="Save">
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="showSWForm" class="col-sm-12 apicredential-form">
                <form [formGroup]="apiSWForm" name="apiSWForm" (keydown.enter)="$event.preventDefault()" novalidate
                      autocomplete="off">
                  <h3 class="mt-5" aria-label="Add CHRN and API Credentials">
                    Add CHRN and API Credentials
                  </h3>
                  <div class="d-flex flex-column">
                    <div class="row mt-2">
                      <div class="col-sm-12 top-space">
                        <div class="col-sm-9 form-group pe-3">
                          <label class="form-label-control" aria-label="CHRN*"
                                 for="chrn">
                            CHRN*
                          </label>
                          <ejs-textbox formControlName="chrn" type="text" name="chrn"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.chrn }" autocomplete="off"
                                       (keyup)="clearFieldErrors('chrn')">
                          </ejs-textbox>
                          <div *ngIf="formErrors?.chrn" class="alert-text">
                            {{formErrors?.chrn}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-sm-12 top-space">
                        <div class="col-sm-9 form-group pe-3">
                          <label class="form-label-control" aria-label="Client ID*"
                                 for="swClientId">
                            Client ID*
                          </label>
                          <ejs-textbox formControlName="swClientId" type="text" name="swClientId"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.swClientId }" autocomplete="off"
                                       (keyup)="clearFieldErrors('swClientId')">
                          </ejs-textbox>
                          <div *ngIf="formErrors?.swClientId" class="alert-text">
                            {{formErrors?.swClientId}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-sm-12 d-flex flex-row">
                        <div class="col-sm-9 form-group pe-3">
                          <label class="form-label-control" for="swClientSecret" aria-label="Client Secret*">
                            Client Secret*
                          </label>
                          <ejs-textbox formControlName="swClientSecret" type="text" name="swClientSecret"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.swClientSecret }" autocomplete="off"
                                       (keyup)="onKeyUpAccessToken($event)" (focus)="changeInputType('swClientSecret'); ">
                          </ejs-textbox>

                          <div *ngIf="formErrors?.swClientSecret" class="alert-text">
                            {{formErrors?.swClientSecret}}
                          </div>
                        </div>
                        <div class="col-sm-3 text-left">
                          <i *ngIf="showEyeIcon" id="pass-status" class="fal fa-eye" aria-hidden="true"
                             (click)="viewPassword('swClientSecret')"></i>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-sm-12 d-flex flex-row">
                        <div class="col-sm-9 form-group pe-3">
                          <label class="form-label-control" aria-label="Confirm Client Secret*"
                                 for="compareSwClientSecret">
                            Confirm Client Secret*
                          </label>
                          <ejs-textbox formControlName="compareSwClientSecret" type="text" name="compareSwClientSecret"
                                       [ngClass]="{required:true, 'is-invalid': formErrors?.compareSwClientSecret }"
                                       autocomplete="off"
                                       (keyup)="onKeyUp($event, dataScopeEnum.SWISSDAMED.toLowerCase());onKeyUpAccessTokenCompare($event)"
                                       (focus)="changeInputType('compareSwClientSecret'); ">
                          </ejs-textbox>

                          <div *ngIf="formErrors?.compareSwClientSecret" class="alert-text">
                            {{formErrors?.compareSwClientSecret}}
                          </div>
                          <div *ngIf="apiSWFormControls.compareSwClientSecret.touched && !isMatch" class="alert-text">
                            <span aria-label="The Client Secret and Confirm Client Secret must match">
                              The Client Secret and Confirm Client Secret must match.
                            </span>
                          </div>
                        </div>
                        <div class="col-sm-1 text-left no-left-padding">
                          <i *ngIf="showEyeIconCompare" id="pass-status-compare" class="fal fa-eye" aria-hidden="true"
                             (click)="viewPasswordCompare('compareSwClientSecret')"></i>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <div class="col-sm-9 form-group">
                          <span aria-label="*Required fields" class="small-print">*Required fields</span>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="d-flex flex-row mt-5 form-group justify-content-center">
                        <div class="col-sm-9">
                          <button class="btn btn-default dialogButton" id="cancel" (click)="cancelForm()"
                                  aria-label="Cancel">
                            Cancel
                          </button>
                          <button class="btn btn-primary dialogButton" id="save" (click)="saveSWForm()"
                                  aria-label="Save">
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

            </div>
          </ng-template>
        </ng-container>
        <ng-container ngbNavItem="languageAdmin" *ngIf="languageTabEnabled">

          <a ngbNavLink role="tab" tabindex="0">
            <span>Language Settings</span>
          </a>
          @if (!displayEditScreen) {
            <ng-template ngbNavContent>
            <ejs-grid [dataSource]="sortedClientLanguageDataNames" #grid [allowSorting]="true" class="grid-striped">
              <e-columns>
                <e-column type='string' field='channel' headerText='Subscribed Channel' width='180'
                  [allowSorting]="true" clipMode='EllipsisWithTooltip'>
                  <ng-template #template let-data>
                    <ng-container *ngIf="displayLink(data.channel); else plainText">
                      <a href="javascript:void(0)" class="pointer" title="Edit Channel"
                        (click)="editChannelLanguages(data)">
                        <i class="fal fa-edit" aria-hidden="true"></i>
                        <span>{{data.channel}}</span>
                      </a>
                    </ng-container>
                    <ng-template #plainText>
                      <span class="ms-3">{{data.channel}}</span>
                    </ng-template>
                  </ng-template>
                </e-column>
                <e-column type='string' field='enabled' headerText='Status' width='90' [allowSorting]="true"
                  clipMode='EllipsisWithTooltip'>
                  <ng-template #template let-data>
                    <span>{{data.enabled ? 'Enabled': 'Disabled'}}</span>
                  </ng-template>
                </e-column>
                <e-column type='string' field='' headerText='Channel Languages' width='250' [allowSorting]="true"
                  clipMode='EllipsisWithTooltip'>
                  <ng-template #template let-data>
                    <!-- {{joinFieldArray(data, 'supportedLanguages')}} -->
                    <ul class="language-ul">
                      <li *ngFor="let language of data['supportedLanguages']">
                        {{language.languageValue}}
                      </li>
                    </ul>
                  </ng-template>
                </e-column>
                <e-column type='string' field='displayLanguage' headerText='Grid Display Language' width='130'
                  [allowSorting]="true" clipMode='EllipsisWithTooltip'>
                  <ng-template #template let-data>
                    {{data.displayLanguage.languageValue}}
                  </ng-template>
                </e-column>
                <e-column type='string' field='modifyUser' headerText='Modified By' width='200' [allowSorting]="true"
                  clipMode='EllipsisWithTooltip'>

                </e-column>
                <e-column type='date' field='modifyDateTime' headerText='Modified Date/Time' width='120'
                  [allowSorting]="true" [format]='formatOptions' clipMode='EllipsisWithTooltip'>

                </e-column>
              </e-columns>
            </ejs-grid>
            </ng-template>
          }
          @if (displayEditScreen) {
            <ng-template #languageEdit ngbNavContent>
            <h1 class="mt-5">Edit Language Settings for {{channelLanguageSupport['channel']}}</h1>
            <div class="row">
              <div class="col-sm-12 mb-3">
                <div *ngIf="channelLanguageEnabled && validationErrors()" aria-label="Please fix the validation errors."
                  class="text-danger">*Please fix validation errors.</div>
              </div>
              <div class="col-sm-12 switch-div">
                <div class="col-sm-12 no-left-padding" aria-label=">Enable or Disable a Channel Language Support">Enable
                  or Disable the Channel Language Support:</div>
                <ejs-switch id="switch" #switch [(ngModel)]="channelLanguageEnabled"
                  (change)="toggleChannelEnableLanguageMode($event)" cssClass="switch"></ejs-switch>
                <label for="languageSwitch" class="switch-label">{{channelLanguageEnabled ? 'Enabled' :
                  'Disabled'}}</label>
              </div>
            </div>
            <div class="row">
              <div class="d-flex">
                <div class="col-sm-3 me-3">
                  <label for="listbox" aria-label="Language Setting - Select one or many">Language Setting - Select
                    one or many:</label>
                  <ejs-listbox id="listbox" #listBox [dataSource]='languagesListBoxDS'
                    [selectionSettings]="listBoxSelection" height="500px" [fields]="listBoxFields"
                    (created)="listBoxCreated()" (change)="listboxSelectionChanged($event)"
                    [enabled]="channelLanguageEnabled">
                  </ejs-listbox>
                  <div class="col-sm-12 text-danger" *ngIf="channelLanguageEnabled && listBoxRequiredError" >At
                    least one language must be selected.</div>
                  <div class="col-sm-12 text-danger" *ngIf="channelLanguageEnabled && languageMaxCountError" >
                    Number of selected languages exceeded allowed maximum.</div>
                </div>
                <div class="col-sm-2">
                  <label for="ddwSelectedLanguages" aria-label="Language Setting - Select one or many">Grid Display
                    Language - Select one:</label>
                  <ejs-dropdownlist [dataSource]="selectedLanguagesArray" id="ddwSelectedLanguages"
                    #ddwSelectedLanguages placeholder='Select one' [fields]="ddwFields"
                    (change)='displayLanguageChanged($event)' [(value)]='selectedDisplayLanguageCode'
                    [enabled]="channelLanguageEnabled"></ejs-dropdownlist>
                  <div *ngIf="channelLanguageEnabled && displayLanguageRequiredError" class="text-danger">Display
                    Language required.</div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="d-flex buttons-div">
                <button type="button" id="btn-cancelLanguageEdit" class="btn btn-default dialogButton"
                  (click)="cancelLanguageEdit()" data-ripple="true">Cancel</button>

                <button type="button" id="btn-saveLanguageEdit" class="btn btn-primary dialogButton"
                  [disabled]="!formModified" (click)="saveLanguageEdit(false)" data-ripple="true">Save</button>
              </div>
            </div>
            </ng-template>
          }

        </ng-container>
      </nav>
      <div [ngbNavOutlet]="tabset"></div>
    </div>
  </div>
</main>


<ejs-dialog #confirmDialog [isModal]='isModal' [buttons]='confirmDlgButtons' [visible]='visible' [position]='position'
  id="confirmDialog" [animationSettings]='animationSettings' [width]='modalWidth'>
  <ng-template #content>
    <div class="card card-primary">
      <div class="card-header bg-primary text-white">
        <h3 class="card-title">Are you sure?</h3>
      </div>
      <div class="card-body" *ngIf="!displayEditScreen; else languageTemplate">
        <span *ngIf="toDelete.appVarName === dataScopeEnum.SKOREA" aria-label=" Do you want to delete the current South Korean API credentials?
        Deleting the current credentials cannot be undone. New or replacement credentials can be found in the South
        Korean system's user admin.">
          Do you want to delete the current South Korean API credentials?<br>
          Deleting the current credentials cannot be undone. New or replacement credentials can be found in the South
          Korean system's user admin.
        </span>
        <span *ngIf="toDelete.appVarName === dataScopeEnum.EUDAMED"
              aria-label="Do you want to delete the SRN from API credentials?
        Deleting the current credentials cannot be undone. New or replacement credentials can be found in the system's user admin.">
          Do you want to delete the {{toDelete.id}} SRN from API credentials?
          Deleting the current credentials cannot be undone. New or replacement credentials can be found in the
          {{toDelete.appVarName}} system's user admin.
        </span>
        <span *ngIf="toDelete.appVarName === dataScopeEnum.AU"
              aria-label="Are you sure you want to delete this TBS ID and Subscription Key?
 Deleting the current credentials cannot be undone. New or replacement credentials can be found in the system's user admin.">
          Are you sure you want to delete this TBS ID - {{toDelete.id}} and Subscription Key?
          Deleting the current credentials cannot be undone. New or replacement credentials can be found in the
          {{toDelete.appVarName}} system's user admin.
        </span>
        <span *ngIf="toDelete.appVarName === dataScopeEnum.SWISSDAMED"
              aria-label="Are you sure you want to delete this CHRN and API Credentials?
 Deleting the current credentials cannot be undone. New or replacement credentials can be found in the system's user admin.">
          Are you sure you want to delete this CHRN - {{toDelete.id}} and API Credentials?
          Deleting the current credentials cannot be undone. New or replacement credentials can be found in the
          {{toDelete.appVarName}} system's user admin.
        </span>
      </div>
    </div>
  </ng-template>
  <ng-template #languageTemplate>
    <div class="card-body">
      <span
        aria-label="Do you really to want to save the changes? The channel setting changes will trigger revalidation of all records that are impacted by the channel/language setting changes. Make sure there are no submission items waiting for internal approval for submission. The channel/language setting changes are not applied to the submission items that are already in submission process">
        Do you really to want to save the changes? <br>The channel setting changes will trigger revalidation of all
        records that are impacted by the channel/language setting changes. Make sure there are no submission items
        waiting for internal approval for submission. The channel/language setting changes are not applied to the
        submission items that are already in submission process.
      </span>
    </div>
  </ng-template>
</ejs-dialog>

<ejs-dialog id="modalDialog" #modalDialog (overlayClick)="overlayClick()" [isModal]='isModal' [width]='modalWidth'
  [buttons]='buttons' [animationSettings]='animationSettings' [visible]='noChangesVodalVisible'>
  <ng-template #content>
    <div class="card card-primary">
      <div class="card-header bg-primary">
        <h4 class="card-title text-white">User entry validation</h4>
      </div>
      <div class="card-body">
        <span class="text-danger">No changes to save.</span>
      </div>
    </div>
  </ng-template>
</ejs-dialog>
<div *ngIf="saving" class="col-sm-12">
  <div id="loading"></div>
</div>
